export enum SegmentStyle {
    Primary,
    Secondary,
    Tertiary
}
